// REACT
import React, { useState, useEffect } from 'react';

// YARN
import { Switch, InputLabel, Box } from '@mui/material';

// SERVICES
import bioLogo from 'assets/images/bio.png';
import './useToggleSwitch.scss';

// INTERFACE
import { IStackedRequestMatrice } from 'components/generics/Interface/RotationMatrices/IStackedRequestMatrice';
import { IFormErrorsMatrices } from 'components/generics/Interface/Commons/IErrorForm';
import { toast } from 'react-toastify';

type OrganicItem = {
  isOrganic: boolean;
  id: number;
};


const useToggleSwitch = (
  from: string,
  params: string,
  refreshData: Function,
  levelId: number,
  stackedRequestsRef?: React.RefObject<IStackedRequestMatrice[]> | null,
  errorsFormDefault?: IFormErrorsMatrices | null | boolean
) => {
  const isOrganicLocalStorage =
    localStorage.getItem('isOrganic') === "false" ? false : true || false

  const isDisabled =
    !!(stackedRequestsRef?.current && stackedRequestsRef.current.length > 0) || !!errorsFormDefault;

  const [isOrganic, setIsOrganic] = useState<boolean>(isOrganicLocalStorage);

  useEffect(() => {
    if (isOrganicLocalStorage) {
      setIsOrganic(isOrganic || false);
    }
  }, [from, params, levelId]);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = event.target.checked;
    setIsOrganic(newState);

    // const updatedState = {
    //   ...isOrganicLocalStorage,
    //   [params]: {
    //     ...isOrganicLocalStorage[params],
    //     [from]: isOrganicLocalStorage[params]?.[from]
    //       ? isOrganicLocalStorage[params][from].some((obj: OrganicItem) => obj.id === levelId)
    //         ? isOrganicLocalStorage[params][from].map((obj: OrganicItem) =>
    //             obj.id === levelId ? { ...obj, isOrganic: newState } : obj
    //           )
    //         : [...isOrganicLocalStorage[params][from], { id: levelId, isOrganic: newState }]
    //       : [{ id: levelId, isOrganic: newState }],
    //   },
    // };
    localStorage.setItem('isOrganic', newState.toString());

    if (stackedRequestsRef && stackedRequestsRef.current) {
      stackedRequestsRef.current.splice(0, stackedRequestsRef.current.length);
    }

    refreshData(newState);
  };

  const handleRenderToast = () => {
    if (isDisabled) {
      if (stackedRequestsRef?.current?.length && errorsFormDefault) {
        toast.error(
          `Des cellules sont en cours de modification et en erreur, veuillez terminer l'édition et corriger les erreurs avant de continuer`
        );
      } else if (stackedRequestsRef?.current?.length) {
        toast.error(
          `Des cellules sont en cours de modification, veuillez terminer l'édition avant de continuer`
        );
      } else if (errorsFormDefault) {
        toast.error(
          `Des cellules sont en erreur, veuillez corriger les erreurs avant de continuer`
        );
      }
    }
  };

  const renderToggleSwitch = () => {
    return (
      <Box className="hook-toggle-switch" onClick={handleRenderToast}>
        <InputLabel className="hook-toggle-switch__label">CONVENTIONNELLE</InputLabel>
        <Switch
          checked={isOrganic}
          onChange={handleToggle}
          color="primary"
          className={`hook-toggle-switch__switch ${isDisabled ? 'hook-toggle-switch__switch-disabled' : ''
            }`}
          disabled={isDisabled ? true : false}
        />
        <Box className="hook-toggle-switch__bio">
          <InputLabel className="hook-toggle-switch__label hook-toggle-switch__label--bio">
            BIO
          </InputLabel>
          <span className="hook-toggle-switch__icon">
            <img src={bioLogo} alt="Logo pinceau" className="hook-toggle-switch__icon-image" />
          </span>
        </Box>
      </Box>
    );
  };

  return {
    renderToggleSwitch,
    isOrganic,
    setIsOrganic,
  };
};

export default useToggleSwitch;
